import store from "../../../common/store/Store";

function SetContactMaxLengthAndValue(obj: any, value: any, entityType: string, fieldType: string) {
  const state = store.getState();
  const model = state.models[fieldType]?.[entityType];
  const length = model?.find((m: any) => m.value === value)?.length;

  if (!value) {
    obj.setPropertyValue("contactMap", null);
    obj.setPropertyValue("crmContactMaxLength", null);
    obj.setPropertyValue("crmMaxLength", null);
  }
  if (length && value) {
    obj.setPropertyValue("crmContactMaxLength", length);
    obj.setPropertyValue("contactMap", value);
    if (
      !obj.getPropertyValue("crmLeadMaxLength") ||
      obj.getPropertyValue("crmLeadMaxLength") === 1 ||
      obj.getPropertyValue("crmLeadMaxLength") > length ||
      obj.getPropertyValue("crmContactMaxLength") < length
    ) {
      obj.setPropertyValue("crmMaxLength", length);
    } else {
      obj.setPropertyValue("crmMaxLength", obj.getPropertyValue("crmLeadMaxLength"));
    }
  }
  if (!length && value) {
    obj.setPropertyValue("contactMap", value);
  }
}

export default SetContactMaxLengthAndValue;
